import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { CycleProjectionPlanningOrchestratorService } from 'orchestrator';
import { ForestryStatusService, RotationPurposeService, RotationUseService } from 'cbd-proxies';
import { Plantation } from '../plantation/plantation';

FieldBuilder.setNamespace('Geographic');

export const ROTATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('rotationValue', 'Entity.Rotation.RotationValue')
    .required()
    .readOnly()
    .build(),
  FieldBuilder
    .date('rotationDate', 'Entity.Rotation.RotationDate')
    .required()
    .readOnly()
    .build(),
  FieldBuilder
    .number('rotationArea', 'Entity.Rotation.RotationArea')
    .required()
    .decimal()
    .readOnly()
    .build(),
  FieldBuilder
    .checkbox('isLastRotation', 'Entity.Rotation.IsLastRotation')
    .readOnly()
    .build(),
  FieldBuilder
    .checkbox('isCupClosed', 'Entity.Rotation.IsCupClosed')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'cycleId',
    'Entity.Cycle',
    CycleProjectionPlanningOrchestratorService
  )
    .required()
    .display('cycleDisplay')
    .displayFromNested('cycleNumber')
    .sortBy('cycleNumber')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'rotationUseId',
    'Entity.RotationUse',
    RotationUseService
  )
    .required()
    .display('name')
    .displayFromNested('rotationUseName')
    .sortBy('rotationUseName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'rotationPurposeId',
    'Entity.RotationPurpose',
    RotationPurposeService
  )
    .display('name')
    .displayFromNested('rotationPurposeName')
    .sortBy('rotationPurposeName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'forestryStatusId',
    'Entity.ForestryStatus',
    ForestryStatusService
  )
    .display('name')
    .displayFromNested('forestryStatusName')
    .sortBy('forestryStatusName')
    .keyField('id')
    .readOnly()
    .build(),
];

export const ROTATION_CONFIG = {
  entityName: 'Rotation',
  localizationKey: 'Geographic::Entity.Rotation',
  fields: ROTATION_FIELDS,
  permission: 'PlanningGeography.Rotations',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
  children: [
    {
      entityName: 'Plantation',
      foreignKeyField: 'rotationId',
      localizationKey: 'Geographic::Entity.Plantation',
      component: Plantation,
    },
  ]
};
